import axios from "axios";
import configs from "config";

export type MessageProps = {
  message?: string;
};

export type APIProductProps = {
  nm_produto: string;
  chave_ativacao: string;
  dt_ativacao: string;
  imagem_produto: string;
  descricao: string;
};

export type ProductProps = {
  productName: string;
  productImage: string;
  description: string;
  activated?: boolean;
  productKey?: string;
  productActivatedDate?: string;
};

export const mapperProducts = (
  apiProducts: APIProductProps[]
): ProductProps[] | [] => {
  if (!apiProducts.length) {
    return [];
  }

  return apiProducts.map((item) => ({
    productName: item.nm_produto,
    productImage: item.imagem_produto,
    description: item.descricao,
    productActivatedDate: item.dt_ativacao,
    productKey: item.chave_ativacao,
  }));
};

const getProducts = async (
  userId: string,
  kl_token: string
): Promise<ProductProps[] | MessageProps> => {
  try {
    console.log("userId", userId);
    console.log("kl_token", kl_token);
    const response = await axios.post(
      `${configs.baseURL}/GetProdutosCampSoft`,
      {
        user_id: userId,
      },
      {
        headers: {
          "kl-token": kl_token,
          "Content-Type": "application/json",
        },
      }
    );

    if (response && response.data && response.data.produtos.length) {
      const productsMapped = mapperProducts(response.data.produtos);

      return productsMapped;
    } else {
      throw Error(response.data.msg_retorno);
    }
  } catch (error) {
    //@ts-ignore
    const errorMessage = error?.response?.data?.msg_retorno || error?.message;

    return {
      message: errorMessage || "Internal server error",
    };
  }
};

export type ErrorProps = {
  message?: string;
  activated?: boolean;
};

export { getProducts };
